document.querySelectorAll('[data-config-gallery]').forEach(gallery => {
  const card = gallery.closest('.schutz-card');
  const checkbox = card.querySelector('.schutz-item');
  const select = card.querySelector('.variant-select');
  const track = gallery.querySelector('[data-config-track]');
  const slides = Array.from(track.children);
  const counter = gallery.querySelector('[data-config-counter]');
  const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
  const move = direction => track.scrollTo({left: ((index() + direction + slides.length) % slides.length) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  const updateSelection = () => slides.forEach(slide => slide.setAttribute('aria-pressed', String(checkbox.checked)));
  const showVariantImage = () => {
    const imageId = select?.selectedOptions[0]?.dataset.imageId;
    if (!imageId) return;
    const position = slides.findIndex(slide => slide.dataset.configImageId === imageId);
    if (position < 0) return;
    track.scrollTo({left: position * track.clientWidth, behavior:'instant'});
    if (counter) counter.textContent = `${position + 1} / ${slides.length}`;
  };
  let pointerStart = null;
  let dragged = false;
  track.addEventListener('pointerdown', event => {pointerStart = {x:event.clientX,y:event.clientY}; dragged = false;}, {passive:true});
  track.addEventListener('pointermove', event => {if (pointerStart && Math.hypot(event.clientX-pointerStart.x,event.clientY-pointerStart.y)>8) dragged=true;}, {passive:true});
  track.addEventListener('pointerup', () => {pointerStart=null;}, {passive:true});
  track.addEventListener('pointercancel', () => {pointerStart=null; dragged=true;}, {passive:true});
  slides.forEach(slide => slide.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    if (event.detail !== 0 && dragged) {dragged=false; return;}
    if (checkbox.disabled) return;
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  checkbox.addEventListener('change', updateSelection);
  gallery.querySelectorAll('[data-config-direction]').forEach(button => button.addEventListener('click', event => {event.preventDefault(); event.stopPropagation(); move(Number(button.dataset.configDirection));}));
  track.addEventListener('scroll', () => {if (counter) counter.textContent = `${index() + 1} / ${slides.length}`;}, {passive:true});
  track.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);}});
  select?.addEventListener('change', showVariantImage);
  updateSelection();
  showVariantImage();
  new ResizeObserver(showVariantImage).observe(track);
});
